'use client'

import { Badge, Button } from '@chain-zen/ui'
import { useState } from 'react'

import { LabelRow } from '../../../shared/label-row'

interface IAdditionalRequirementsProps {
  requirements: string[]
}

/**
 * Additional requirements component renders a list of additional requirements of an equipment type for a post
 */
export const AdditionalRequirements = ({ requirements }: IAdditionalRequirementsProps) => {
  const [showAllRequirements, setShowAllRequirements] = useState(false)

  if (!requirements || requirements.length === 0) return null

  const displayedRequirements = showAllRequirements ? requirements : requirements.slice(0, 6)
  const hasMore = requirements.length > 6

  return (
    <LabelRow label="Additional requirements">
      <div className="flex flex-wrap gap-2 items-center float-right">
        {displayedRequirements.map((requirement, index) => (
          <Badge key={index} variant="outline">
            {requirement}
          </Badge>
        ))}
        {!!hasMore && !showAllRequirements && (
          <Button size="sm" onClick={() => setShowAllRequirements(true)}>
            +{requirements.length - 6} more
          </Button>
        )}
        {!!hasMore && !!showAllRequirements && (
          <Button size="sm" onClick={() => setShowAllRequirements(false)} className="ml-1">
            Show less
          </Button>
        )}
      </div>
    </LabelRow>
  )
}
